import store from "./store";
import { customLogger } from "@/utils";

export default {
    force_next_step() {
        const condition = store.state.config.steps[store.state.user.style_profile_key].condition;

        if (condition && condition['seeMore'])
            this.generateNextStyleProfileStep('seeMore')
        else
            this.generateNextStyleProfileStep()
    },
    generateNextStyleProfileStep(value = null, to_send = null, last_step = null) {

        // saving condition to help NEXT_KEY_STYLE_PROFILE_STEP
        if (store.state.user.style_profile_key != null) {
            const step = store.state.config.steps[store.state.user.style_profile_key];

            if (step.condition != null)
                store.commit("UPDATE_DATA", {condition: value});
        }

        let data = {}

        // saving value of step, ex: brands: ['balanciaga'] | the user only selected balanciaga
        if (last_step)
            data[last_step] = to_send ? to_send : value
        else
            data[store.state.user.style_profile_key] = to_send ? to_send : value

        // saving last key where user stopped
        let to_save = {
            to_save: {
                last_step: (last_step) ? last_step : store.state.user.style_profile_key,
            }
        };

        if(window.matomoTracker) {
            if(store.state.user.data.condition == "recommendation")
                matomoTracker.trackEvent('Chat', 'New Step', "see_reco")
            else
                matomoTracker.trackEvent('Chat', 'New Step', to_save.to_save['last_step'])
        }
        // I don't remenber, I thing it's for api
        to_save.to_save = { ...to_save.to_save, ...data }

        store.commit('SET_TO_SAVE', to_save)

        store.commit('DELETE_TMP_CONTENT')

        store.dispatch("FETCH_STYLE_PROFILE_STEP");
    },

    NEXT_KEY_STYLE_PROFILE_STEP: async () => {
        var keyStore = "";

        if (store.state.user.style_profile_key == null &&
            store.state.user.data && store.state.user.data.last_step)
            await store.commit('SET_STYLE_PROFILE_KEY', store.state.user.data.last_step)

        if (store.state.user.style_profile_key == null) {
            if (!store.state.config.steps) {
                store.commit("DISABLE_STYLE_PROFILE");
                return null;
            } else {
                keyStore = Object.keys(store.state.config.steps)[0];
                store.commit("SET_STYLE_PROFILE_KEY", keyStore);
                return keyStore;
            }
        } else {
            keyStore = store.state.user.style_profile_key;
            var step = store.state.config.steps[keyStore];

            if (step.next != null && store.state.config.steps[step.next] != null) {
                store.commit("SET_STYLE_PROFILE_KEY", step.next);
                return step.next;
            } else {
                // test if previous step was a condition
                if (store.state.config.storeId == 33 || store.state.config.storeId == 49) {
                    const quiz_step = [
                        "get_quiz_condition",
                        "brands_male_t-shirt",
                        "brands_male_jacket",
                        "brands_male_trench",
                        "brands_male_coat",
                        "brands_male_sweat",
                        "brands_male_suits",
                        "brands_male_shirts",
                        "brands_male_trousers",
                        "brands_male_jeans",
                        "brands_male_jumpsuits",
                        "brands_male_underwear",
                        "brands_female_dress",
                        "brands_female_skirts",
                        "brands_female_t-shirt",
                        "brands_female_jacket",
                        "brands_female_trench",
                        "brands_female_coat",
                        "brands_female_sweat",
                        "brands_female_shirts",
                        "brands_female_trousers",
                        "brands_female_jumpsuits",
                        "brands_female_jeans",
                        "brands_female_swimwear",
                        "brands_female_sport",
                        "brands_female_bras",
                        "brands_female_bottom",
                        "brands_female_body",
                        "brands_female_homewear",
                        "brands_female_hoisiery",
                        "brands_female_hoisiery",
                        "get_brands_condition",
                        "brands_male_sneakers",
                        "brands_male_boots",
                        "brands_male_derbies",
                        "brands_male_sandals",
                        "brands_male_espadrilles",
                        "brands_female_sneakers",
                        "brands_female_boots",
                        "brands_female_derbies",
                        "brands_female_sandals",
                        "brands_female_espadrilles",
                        "brands_female_pumps",
                        "brands_female_ballerinas",
                        "brands_male_bag",
                        "brands_male_briefcases",
                        "brands_male_small_leather",
                        "brands_male_week-end_bags",
                        "brands_male_high-tech",
                        "brands_female_bag",
                        "brands_female_goods",
                        "brands_female_week-end_bags",
                        "brands_female_high-tech",
                        "brands_male_sunglasses",
                        "brands_male_silks",
                        "brands_male_hats",
                        "brands_male_beanies",
                        "brands_male_scarfs",
                        "brands_male_gloves",
                        "brands_male_belts",
                        "brands_female_sunglasses",
                        "brands_female_silks",
                        "brands_female_beanies",
                        "brands_female_scrafs",
                        "brands_female_gloves",
                        "brands_female_belts",
                        "brands_male_goods",
                        "brands_female_hosiery",
                        "brands_female_small_leather",
                        "brands_female_hats",
                        "style_necklaces",
                        "style_watches",
                        "style_deco",
                        "style_hightech",
                        "style_library",
                        "style_delicatessen",
                        "style_candles",
                        "style_home"
                    ]
                    const brand_step = [
                        "sub-sub-category-bag-male",
                        "sub-sub-category-bag-female",
                        "sub-sub-category-small-leather-male",
                        "sub-sub-category-small-leather-female",
                        "sub-sub-category-silks-male",
                        "sub-sub-category-silks-female",
                        "sub-sub-category-hats-male",
                        "sub-sub-category-hats-female",
                        "sub-sub-category-beanies-male",
                        "sub-sub-category-beanies-female",
                        "sub-sub-category-scarfs-male",
                        "sub-sub-category-scarfs-female",
                        "sub-sub-category-watches-male",
                        "sub-sub-category-rings-male",
                        "sub-sub-category-bracelets-male",
                        "sub-sub-category-cuff-links-male",
                        "sub-sub-category-necklaces",
                        "sub-sub-category-watches-female",
                        "sub-sub-category-rings-female",
                        "sub-sub-category-bracelets-female",
                        "sub-sub-category-cuff-links-female",
                        "sub-sub-category-face_care",
                        "sub-sub-category-soap",
                        "sub-sub-category-haircare",
                        "sub-sub-category-sun_care",
                        "sub-sub-category-nailcare",
                        "sub-sub-category-deco",
                        "sub-sub-category-hightech",
                        "sub-sub-category-library",
                        "sub-sub-category-delicatessen",
                        "sub-sub-category-candles",
                        "sub-sub-category-home",
                        "sub-sub-category-head_jewels",
                        "usual_size_male",
                        "usual_size_female",
                        "shirts_size_male",
                        "tops_size_female",
                        "coats_size_male",
                        "pants_size_male",
                        "pants_size_female",
                        "jeans_size_male",
                        "jeans_size_female",
                        "shoes_size_female",
                        "shoes_size_male",
                        "size_lingerie_female",
                        "get_brands_condition"
                    ]
                    for (let item of brand_step) {
                        if (store.state.user.data.selected_brands != undefined &&
                            (store.state.user.data.last_step === item)) {
                                // customLogger("Dans le if dans style-profile pour size")
                                store.state.user.data.condition = store.state.user.data.selected_brands
                        }
                    }
                    for (let values of quiz_step) {
                        if (store.state.user.data.selected_quiz != undefined && 
                            (store.state.user.data.last_step === values)) {
                                // customLogger("Dans le if dans style-profile pour quiz")
                                store.state.user.data.condition = store.state.user.data.selected_quiz
                        }
                    }
                    if (store.state.user.data.selected_filter != undefined) {
                        if (store.state.user.data.last_step === "FILTER") {
                            store.state.user.data.condition = "get_filter_condition"
                        }
                        else if (store.state.user.data.last_step === "get_filter_condition") {
                            store.state.user.data.condition = store.state.user.data.selected_filter
                            store.commit('RESET_SELECTED_FILTER')
                        }
                    }
                }

                if (
                    step.condition != null &&
                    step.condition[store.state.user.data.condition] != null &&
                    store.state.config.steps[step.condition[store.state.user.data.condition]] != null
                ) {
                    store.commit("SET_STYLE_PROFILE_KEY", step.condition[store.state.user.data.condition]);
                    return step.condition[store.state.user.data.condition];
                } else {
                    customLogger(
                        "the step '",
                        step.next ?
                            step.next :
                            step.condition ?
                                JSON.stringify(step.condition) + ' with condition ' + JSON.stringify(store.state.user.data.condition) :
                                "none",
                        "' is invalid check data.json current step is " + store.state.user.style_profile_key
                    );
                    store.commit("DISABLE_STYLE_PROFILE");
                    store.commit("SET_STYLE_PROFILE_KEY", null);
                    return null;
                }
            }
        }
    }
}
